import { getTimeZones } from '@vvo/tzdb';

const getTimezone = timezoneName => {

  const timezones = getTimeZones();

  for(let i = 0; i <= timezones.length; i++) {
    let timezone = timezones[i];

    if(timezone.name === timezoneName) {
      return timezone;
    }
  }

  return false;

};

export default getTimezone;
